import React from 'react';

import Container from '@src/components/Shared/Container';
import SectionHeader from '@src/components/Shared/SectionHeader';

import { VideoTextPrimaryPropTypes } from './VideoTextPrimary.types';

const VideoTextPrimary: React.FC<VideoTextPrimaryPropTypes> = ({
  id,
  className,
  pretitle,
  title,
  titleClassName,
  videoURL,
  background,
  childrenElements,
  reversed = false,

  // Passing additional Classes via Props for more flexibility
  videoClassName = '',
  textContainerClassName = '',
  sectionHeaderClassName = '',
}) => {
  return (
    <Container
      id={id}
      className={`flex flex-col gap-[4.2rem] overflow-y-hidden lg:flex-row lg:items-center lg:gap-[6.4rem] ${className}`}
      background={background}
    >
      <video
        src={videoURL}
        className={`lg:mb-[unset] lg:w-[50%] ${videoClassName} ${reversed ? 'lg:order-1' : ''}`}
        muted
        autoPlay
        loop
        playsInline
      ></video>

      <div className={`lg:relative lg:z-20 lg:w-[50%] ${textContainerClassName}`}>
        <SectionHeader
          className={`lg:relative lg:z-5 lg:py-[10rem] ${sectionHeaderClassName}`}
          pretitle={pretitle}
          preTitleClassName='mb-[1.6rem]'
          title={title}
          titleClassName={`text-[2.8rem] leading-[3.2rem] mb-[1.8rem] lg:mb-[3.2rem] lg:text-[4.8rem] lg:leading-[5rem] lg:tracking-[-0.096rem] ${titleClassName}`}
          childrenClassName='relative'
          align='left'
        >
          {childrenElements}
        </SectionHeader>
      </div>
    </Container>
  );
};

export default VideoTextPrimary;
